<div class="container ">
  <app-shared-action-bar [saveReady]="hasChange && !saving" [undoReady]="hasChange && !saving"
    [displayActionSectionBar]="showActionSectionBar && viewMode === 'active'" (saveRequest)="saveChanges()"
  (undoRequest)="undoChanges()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">
    <div class="my-4">
      @if (!isNewLocation) {
        <h2 class="settings-header">Edit Location</h2>
      }
      @if (isNewLocation) {
        <h2 class="settings-header">New Location</h2>
      }
    </div>
    @if (!isNewLocation) {
      <div class="flex gap-2 mb-4" role="tablist" aria-label="Location status">
        <button class="btn-inverse" [class.btn-primary]="viewMode === 'active'" (click)="setViewMode('active')" role="tab" [attr.aria-selected]="viewMode === 'active'">Active Locations</button>
        <button class="btn-inverse" [class.btn-primary]="viewMode === 'removed'" (click)="setViewMode('removed')" role="tab" [attr.aria-selected]="viewMode === 'removed'">Removed Locations</button>
      </div>
    }
    @if (viewMode === 'removed' && !isNewLocation) {
      <div class="mt-4">
        @if (loadingRemovedLocations) {
          <p>Loading removed locations...</p>
        } @else if (removedLocations.length === 0) {
          <p class="text-grey-700">There are no removed locations available to reactivate.</p>
        } @else {
          <ul>
            @for (location of removedLocations; track location.LocationID) {
              <li class="border my-2 border-grey-900 rounded-lg p-4 flex flex-col md:flex-row md:items-center justify-between gap-3">
                <div>
                  <h3>{{location.LocationName}}</h3>
                  @if (location.ParentLocationName) {
                    <p class="text-sm text-grey-700">Parent: {{location.ParentLocationName}}</p>
                  }
                </div>
                <button class="btn-primary" (click)="reactivateLocation(location)" [disabled]="reactivatingLocationIds.has(location.LocationID)">
                  @if (reactivatingLocationIds.has(location.LocationID)) { Reactivating... } @else { Reactivate }
                </button>
              </li>
            }
          </ul>
        }
      </div>
    }
    <div class="mt-4" [class.hidden]="viewMode === 'removed' && !isNewLocation">

  @if (isLocationSelected && !isNewLocation) {
    <div class="mt-4 flex items-center">
      <p class="settings-selected-item mr-2">{{currentLocationHeader}} </p>@if (!currentActiveStatus) {
      <span class="ml-2 text-grey-900 text-2xl font-bold"
      >(Inactive)</span>
      }<span (click)="changeLocation()"
      class="hover:cursor-pointer text-xl material-symbols-outlined">
      edit
    </span>
  </div>
}
@if (!isLocationSelected && !isNewLocation) {
  <div class="mt-4">
    <p class="text-2xl font-bold">Select Location</p>
    @if (showLocation) {
      <div class="p-4">
        @if (!topLevel) {
          <div class="flex " >
            <span
              class="text-center hover:cursor-pointer material-symbols-outlined text-green-700 self-center mr-1 "(click)="resetLocations()"
            >undo</span><span class="hover:cursor-pointer" (click)="resetLocations()">Reset
          Locations</span>
          <!-- <span
          class="text-center material-symbols-outlined text-green-700 self-center mr-1 hover:cursor-pointer"
          (click)="previousLevel()">arrow_upward_alt</span><span>Previous Level</span>-->
        </div>
      }
      @if (locationsReady) {
        <div>
          @for (l of possibleLocations; track l) {
            <div class="flex w-full my-2">
              <span
                class="p-2 md:p-4 flex-grow standardTextSize border-spacing-1.5 border-b-grey-500 border-s-2 flex  align-middle "
                [ngClass]="{'selected': l.LocationID == selectedLocation.LocationID, 'hover:hover-for-select  ':l.HasPermission, 'bg-grey-100 hover:cursor-not-allowed':!l.HasPermission,' bg-grey-300':l.HasPermission&&l.LocationID!=selectedLocation.LocationID}"
                (click)="selectLocation(l)">{{l.LocationName}}@if (!l.Active) {
                <span
                class="ml-2 text-grey-900 font-bold">(Inactive)</span>
              }</span>
              @if (locationHasChildren(l)) {
                <div class=" bg-standardwhite "
                  (click)="buildLocationDDL(l.LocationID)">
                  <span
                    class="standardTextSize text-offblack hover:hover-for-select bg-grey-300 border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub
                  Locations</span>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
}
@if (isLocationSelected) {
  <div class="mt-6">
    @if (true) {
      <div>
        <label class="mr-2">Location Name</label>
        <input type="text" class="text-box lg:w-3/5" [(ngModel)]="selectedLocation.LocationName"
          (keyup)="checkForChange()" />
          <!---->
        </div>
      }

    <div class="mt-3"
      [ngClass]="{'border-[1px] border-grey-100 border-solid rounded-lg shadow-sm shadow-grey-300 my-4':editingParent}">
      @if (!editingParent) {
        <label>Parent Location</label>
      }
      @if (editingParent) {
        <div class="flex justify-between mt-2 mx-3">
          <h4 class="font-bold text-green-700">Select Parent Location</h4>
          <div class="flex items-center"><span
          class="text-center material-symbols-outlined text-danger-base self-center mr-1">close</span>
          <p (click)="clearParent()" class="text-danger-base hover:underline hover:cursor-pointer">Remove
          Parent Location</p>
        </div>
      </div>
    }
    @if (!editingParent) {
      <div class="flex items-center mt-2">
        @if (!editingParent && hasEditParent) {
          <span class="material-symbols-outlined text-sm cursor-pointer px-2"
          (click)="switchParentEdit()">edit</span>
        }
        @if (!hasAvailableParent) {
          <p class="">Location does not have a parent location @if (!hasEditParent) {
            <span
            >and no valid parent locations</span>
          }</p>
        }
        @if (hasAvailableParent) {
          <p>{{getParentLocation().LocationName}}</p>
        }
      </div>
    }
    @if (parentListAvailable && editingParent) {
      <div class="p-4 ">
        <div>
          @if (!topParentLevel) {
            <div class="flex">
              <div (click)="setParentList()"
                class="flex items-center hover:cursor-pointer hover:text-green-700">
                <span
                class="text-center material-symbols-outlined text-green-700 self-center mr-1 ">undo</span><span>Reset
              Locations</span>
            </div>
            <div (click)="previousLevel()"
              class="flex items-center hover:cursor-pointer ml-2  hover:text-green-700">
              <span
              class="text-center material-symbols-outlined text-green-700 self-center mr-1 ">arrow_upward_alt</span><span>Previous
            Level</span>
          </div>
        </div>
      }
      @for (l of displayParents; track l) {
        <div class="flex w-full my-2">
          <span
            class="p-2 md:p-4 flex-grow standardTextSize border-spacing-1.5 border-b-grey-500 border-s-2 flex justify-between align-middle hover:hover-for-select "
            [ngClass]="{'selected': l.LocationID == selectedParent.LocationID, ' bg-grey-300':l.LocationID!=selectedParent.LocationID}"
          (click)="selectParentLocation(l)">{{l.LocationName}}</span>
          @if (parentLocationHasChildren(l)) {
            <div class=" bg-standardwhite "
              (click)="updateParentList(l.LocationID)">
              <span
                class="standardTextSize text-offblack hover:hover-for-select bg-grey-300 border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub
              Locations</span>
            </div>
          }
        </div>
      }
    </div>
    <div class="flex flex-col mt-3  lg:w-3/5 xl:w-2/5 ">
      <button class="btn-primary confirmButton" (click)="confirmParentLocation()"
        [disabled]="selectedParent.LocationID == -1">@if (selectedParent.LocationID == -1) {
        <span
        >Select Parent</span>
        }@if (selectedParent.LocationID != -1) {
        <span
        >Confirm Parent Location</span>
      }</button>
      <button class="btn-inverse mt-3" (click)="cancelParentChange()">Cancel</button>
    </div>
  </div>
}
</div>
<div class=" lg:w-3/5 xl:w-2/5 mt-3">
  <div class="flex flex-col">
    <label class="mr-2 ">Active </label>
    <app-toggle-switch class="mt-2" [(checked)]="selectedLocation.Active" (checkedChange)="checkForChange()"></app-toggle-switch>
  </div>

</div>
</div>
}
</div>
</div>
</div>
